<template>
    <vs-sidebar click-not-close :parent="parent" :hidden-background="true" class="full-vs-sidebar question-banks-view-sidebar items-no-padding" v-model="isSidebarActive" position-right>
        <div class="question-bank-sidebar-content bg-white px-0 sm:pb-6 h-full" v-if="questionBank">
            <div class="flex items-center question-banks-header md:px-8 px-6 sm:pb-2 sm:pt-6 d-theme-dark-bg">
                <div class="flex mb-4 lg:max-w-full max-w-xs">
                    <div class="flex items-center w-full">
                        <div class="mr-4 mt-2">
                            <feather-icon :icon="$vs.rtl ? 'ArrowRightIcon' : 'ArrowLeftIcon'" @click="$emit('closeSidebar')" class="cursor-pointer" svg-classes="w-6 h-6"></feather-icon>
                        </div>
                        <h4 class="truncate">{{ questionBank.title }}</h4>
                        <span class="ml-2">({{bankType}})</span>
                    </div>
                </div>
            </div>

            <VuePerfectScrollbar class="scroll-area-question-bank-content md:px-8 md:pb-8 pt-4 px-6 pb-6" :settings="settings" :key="$vs.rtl">
              <!-- LABEL ROW -->
              <div v-if="!viewOnly" class="vx-row">
                <div class="vx-col w-full">
                  <div class="question-banks__labels--single flex items-center justify-between mt-2">
                    <h4 :key="questionBank.id">
                      <span>{{questionBank.questions.length}} اسئلة</span>
                      <small class="ml-2">({{totalMarks}} نقطة)</small>
                    </h4>
                      <vs-button @click="isPrinterActive = true" class="ml-4">طباعة النموذج</vs-button>
                  </div>
                </div>
              </div>
              <div v-else-if="questionBank.questions.length > 0">
                <div class="flex my-2">
                  <vs-checkbox
                    :key="isCheckedLine ? 'remove' : 'check'"
                    :icon="isCheckedLine ? 'remove' : 'check'"
                    :checked="isCheckedMultiple"
                    @click.prevent="selectAllQuestions"></vs-checkbox>
                  <span class="ml-2 text-lg">تحديد الكل</span>
                </div>
              </div>
              <!-- /LABEL ROW -->
              <br>
              <div v-if="isSidebarActive">
                <div class="w-full" v-for="(question, index) in questionBank.questions" :key="index">
                  <div v-if="viewOnly" class="flex mb-2">
                    <vs-checkbox v-model="selectedQuestions" :vs-value="question"></vs-checkbox>
                    <span class="ml-2 text-lg">سؤال {{index+1}}</span>
                  </div>
                  <question-item  @save="save(...arguments, index)"
                                  @remove="removeQuestion"
                                  :data="question" :view-only="viewOnly || questionBank.type === 'quiz'" />
                </div>
              </div>
              <vs-button v-if="!viewOnly && questionBank.type !== 'quiz'" @click="addNewQuestion" class="rounded-full" color="success" icon="icon-plus" icon-pack="feather" icon-after>إضافة سؤال</vs-button>
            </VuePerfectScrollbar>
        </div>
        <question-bank-printer :data="questionBank" :active.sync="isPrinterActive"/>
    </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import QuestionItem from '@/views/questionBanks/QuestionItem'
import questionsAPI from '@/api/questionsAPI'
import questionsBanksAPI from '@/api/questionsBanksAPI'
import QuestionBankPrinter from '@/views/questionBanks/QuestionBankPrinter'

export default {
  props: {
    openQuestionBankId: {
      required: true,
      validator: prop => typeof prop === 'number' || prop === null
    },
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    viewOnly: {
      type: Boolean,
      default: false
    },
    parent: {
      type: String,
      default: '#question-banks-app'
    },
  },
  data() {
    return {
      isPrinterActive: false,
      questionBank: null,
      questions: [],
      selectedQuestions: [],
      settings: {
        maxScrollbarLength: 60,
        wheelPropagation: true,
      },
    }
  },
  watch: {
    isSidebarActive(value) {
      if (!value) {
        this.selectedQuestions = []
        this.$emit('closeSidebar')
      } else {
          this.$startLoading(this.parent, 'white')
          this.$store.dispatch('questionBanks/getQuestionsBank', this.openQuestionBankId).then(questionBank => {
              this.questionBank = questionBank
              this.questions = questionBank.questions
              this.$closeLoading(this.parent)
          })
      }
    },
    selectedQuestions(questions){
        this.$emit('selectedQuestions', questions)
    },
  },
  computed: {
    isCheckedLine () {
        return this.selectedQuestions.length !== this.questions.length
    },
    isCheckedMultiple () {
        return this.selectedQuestions.length > 0
    },
    bankType() {
        switch (this.questionBank.type) {
            case 'public' : return 'عام'
            case 'private' : return 'خاص'
            case 'quiz' : return 'إختبار'
            default : return ''
        }
    },
    totalMarks() {
        return this.questions.reduce((total, questions) => total + parseInt(questions.mark), 0)
    },
  },
  methods: {
    extract() {
        questionsBanksAPI.extract(this.questionBank.id, this.questionBank.title)
    },
    selectAllQuestions() {
        if(this.selectedQuestions.length < this.questions.length){
            this.selectedQuestions = this.questions
        } else {
            this.selectedQuestions = []
        }
    },
    addNewQuestion(){
        this.questions.push({ questions_bank_id: this.questionBank.id, answer:0, mark:1, tags:'', title:'', type:"plain" })
    },
    save(question, index){
        if(question.duplicated) {
            delete question.duplicated
            this.questions.push(question)
        } else {
            this.questions.splice(index, 1, question)
        }
    },
    removeQuestion(question){
        if(!question.id){
            this.$delete(this.questions, this.questions.indexOf(question))
            return
        }
        let message = `هل انت متأكد حذف السؤال؟`
        this.$confirmAlert(null, message, () => {
            questionsAPI.delete(question.id)
                .then(response => {
                    const index = this.questions.findIndex(q => q.id === question.id)
                    this.$delete(this.questions, index)
                    this.$notifySuccess(response.successMessage)
                })
                .catch(error => this.$notifyError(error.statusMessage))
        })
    },
  },
  components: {
      QuestionBankPrinter,
    VuePerfectScrollbar,
    QuestionItem
  },
}

</script>

